import { IdentityVerificationStatus } from "Infrastructure/Api/Api";
import type { CodeListItem } from "Models/ICodeListDto";
import { Resources, useResource } from "Translations/Resources";
import { useMemo } from "react";

type ListItem = CodeListItem<IdentityVerificationStatus>;
type Result = ListItem[];

export const useIdentityVerificationStatusList = () => {
  const { t } = useResource();

  return useMemo<Result>(
    () =>
      Object.entries(IdentityVerificationStatus).map<ListItem>(([key]) => ({
        code: key as IdentityVerificationStatus,
        name: t(
          Resources.Form.IdentityVerification[
            key as IdentityVerificationStatus
          ],
        ),
      })),
    [t],
  );
};
